import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded, FuseAnimateGroup } from '@fuse';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Tab, Tabs, Grid, Divider, DialogTitle, DialogContent, DialogActions, Dialog, TextField } from '@material-ui/core';
import * as courseActions from '../../course/store/actions';
import RelationUpdateTabs from '../../../components/RelationUpdateTabs';
import _ from 'lodash';
import ScaffoldForm from './ScaffoldForm';
import * as Actions from '../store/actions';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        },
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
});

class BuilderFormContainer extends Component {
    state = {
        current_tab: 0,
        tabValue: 0,
    }

    constructor(props) {
        super(props);
        this.props.getCompanyList()
    }


    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        })
    }

    handleTabChange = (event, value) => {
        this.setState({ tabValue: value });
    };

    handleChangeIndex = index => {
        this.setState({ value: index });
    };

    getPageContent = (current_tab, view_type) => {

        switch (current_tab) {
            case (0): // Detail
                {
                    return <ScaffoldForm />
                }
            case (1): // Content
                {
                    return (
                        <React.Fragment>
                            <Grid item xs={6}>
                                <RelationUpdateTabs
                                    currentRelationsTabData={this.props.companies}
                                    handleDelete={this.props.toggleCompany}
                                    availableObjectList={this.props.allCompanies}
                                    handleAdd={this.props.toggleCompany}
                                    handleSearchChange={this.builderCompanyUpdateSearch}
                                    search={this.props.companySearch}
                                    leftHeader="Current Companies"
                                    rightHeader="All Companies"
                                    view_type={view_type}
                                    rootClass={this.props.classes.root}
                                    dir={this.props.theme.direction}
                                />
                            </Grid>
                        </React.Fragment>)
                }
            default:
                {
                    <div>no tab</div>
                }
        }
    }


    render() {
        const { classes, auth } = this.props;
        const { current_tab, view_type } = this.state;
        const page_content = this.getPageContent(current_tab, view_type);
        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    null
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Detail"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Relation"
                                />
                            </Tabs>

                            />
                        </Grid>
                    </div>
                }
                content={
                    <React.Fragment>
                        {page_content}
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        builderCompanyUpdateSearch: Actions.builderCompanyUpdateSearch,
        getCompanyList: Actions.getCompanyList,
        toggleCompany: Actions.builderToggleCompany
    }, dispatch);
}

function mapStateToProps({ auth, courseApp }) {
    return {
        companies: courseApp.courseBuilder.courseScaffold.companies,
        allCompanies: courseApp.courseBuilder.allCompanies,
        companySearch: courseApp.courseBuilder.companySearch,
        auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(BuilderFormContainer)));



// WEBPACK FOOTER //
// src/main/content/course/builderComponents/BuilderFormContainer.js